import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { pagesList } from "Apis/pages";
import { fetchQrTemplateListApi } from "Apis/qrTemplate";

export const QrTemplateContext = createContext();

export const QrTemplateContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [qrTempListData, setQrTempListData] = useState([]);

  const allPagesList = async () => {
    const response = await pagesList({
      filters: {
        slug: "home_page",
      },
    });
    const pages = response?.data?.data?.rows?.map((data) => ({
      label: data?.slug.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
      value: data?.slug,
    }));
    setPageList(pages);
  };

  const getQrTempApi = async () => {
    let response = await fetchQrTemplateListApi();
    if (response?.status === 200) {
      setQrTempListData(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.title,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <QrTemplateContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        pageList,
        setPageList,
        allPagesList,
        qrTempListData,
        setQrTempListData,
        getQrTempApi,
      }}
    >
      {children}
    </QrTemplateContext.Provider>
  );
};

export default QrTemplateContextProvider;
QrTemplateContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
